import React from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function MtbfProductSeriesCard({ groups }) {
  const list = Array.isArray(groups) ? groups : [];

  return (
    <div style={{ ...card.shell, maxWidth: '760px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Series grouping</p>
          <h2 style={card.title}>MTBF Product Series</h2>
        </div>
      </div>
      <div style={card.body}>
        <div style={card.section}>
          {list.length > 0 ? (
            <ul style={{ ...card.list, color: colors.textBody }}>
              {list.map(group => {
                const rawHours = typeof group.totalOperatingTime === 'number' ? group.totalOperatingTime : null;
                const failures = Number(group.failures) || 0;
                const mtbfHours = failures > 0 && rawHours !== null ? Math.round(rawHours / failures) : null;
                const mtbfYears = mtbfHours !== null ? Math.round(mtbfHours / 8760) : null;
                return (
                  <li key={group.code} style={{ marginBottom: '0.9rem' }}>
                    <div style={{ color: colors.textStrong, fontWeight: 600 }}>
                      {group.name}: {mtbfHours !== null ? mtbfHours.toLocaleString() : 'N/A'} hours / {mtbfYears !== null ? mtbfYears.toLocaleString() : 'N/A'} years
                    </div>
                    <div style={{ fontSize: '0.85rem', color: colors.textMuted }}>
                      Based on {rawHours !== null ? Math.round(rawHours).toLocaleString() : 'N/A'} cumulative fleet hours.
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div style={{ color: colors.textMuted }}>No data available</div>
          )}
        </div>
      </div>
    </div>
  );
}
